import type { FileItem } from '../types';

// 拖拽相关的工具函数

// 根据ID查找文件项
export function findItemById(items: FileItem[], id: string): FileItem | null {
  for (const item of items) {
    if (item.id === id) return item;
  }
  return null;
}

// 验证拖拽操作是否有效
export function validateDragOperation(
  activeId: string,
  overId: string,
  selectedItems: string[],
  files: FileItem[],
): { isValid: boolean; itemsToMove: FileItem[]; overItem: FileItem | null } {
  // 不能拖拽到自己身上
  if (activeId === overId) {
    return { isValid: false, itemsToMove: [], overItem: null };
  }

  const activeItem = findItemById(files, activeId);
  const overItem = findItemById(files, overId);

  if (!activeItem || !overItem) {
    return { isValid: false, itemsToMove: [], overItem: null };
  }

  // 只能将项目拖拽到文件夹中
  if (overItem.type !== 'folder') {
    return { isValid: false, itemsToMove: [], overItem };
  }

  // 获取要移动的项目列表
  const itemsToMove = selectedItems.includes(activeId)
    ? (selectedItems.map((id) => findItemById(files, id)).filter((item) => item !== null) as FileItem[])
    : [activeItem];

  return { isValid: true, itemsToMove, overItem };
}
